import React, { Component } from "react";
import { render } from "react-dom";
// import HomePage from "./components/page";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import Button from '@mui/material/Button';
import darkTheme from '../theme/darkTheme';
import lightTheme from '../theme/lightTheme';
import { ThemeProvider } from '@mui/material/styles';


import FinChat from '../pages/finchat'
import FreightRates from '../pages/freight-rates'
import DataGridDemo from '../pages/correlation'
import Strategies from "../pages/strategy_dashboard";
import SupersetDashboard from "../pages/superset_dashboard";

import axios from 'axios';
import {get_tickers} from '../apis/analysis-apis'

import SendIcon from '@mui/icons-material/Send';

import { useEffect, useState } from "react";


export default function App()  {

  // // Add a request interceptor
  axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    // config.headers['X-CSRFToken']= window.CSRF_TOKEN;  // Include the CSRF token here
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });



    return (
    <ThemeProvider theme={darkTheme}>
        <Router>
        <Routes>
            <Route path="/users/finchat/" element={<FinChat />} />
        </Routes>
        <Routes>
            <Route path="/users/workspace/macro/freight-rates/" element={<FreightRates />} />
        </Routes>
        <Routes>
            <Route path="/users/workspace/causal/analysis/correlation-dashboard/" element={<DataGridDemo />} />
        </Routes>
        <Routes>
            <Route path="/users/workspace/strategies/strategies-dashboard/" element={<Strategies />} />
        </Routes>
        <Routes>
            <Route path="/users/workspace/:subMenu/:dashboardName" element={<SupersetDashboard />} />
        </Routes>
        </Router> 
    </ThemeProvider>
    );
  }



const container = document.getElementById('react-app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App tab="home" />);